import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  PATCH: 'COURSE_CLASS_LOG_PATCH',
  PATCH_SUCCESS: 'COURSE_CLASS_LOG_PATCH_SUCCESS',
  PATCH_FAILURE: 'COURSE_CLASS_LOG_PATCH_FAILURE',
};

export const patch = actions.patch(
  classLogId => `${BASE_URL}/student-course-class-log/${classLogId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
